import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePeriscopeNextGenRoute: InvariantJiraRoute = {
	name: 'software-periscope',
	path: '/jira/software/projects/:projectKey/development',
};
